import React, { useState } from "react";
import { Modal, Form, Button, Alert } from "react-bootstrap";
import { addVideoFavourites, deleteVideoFavourites } from "../../../apis/all_user_video";

export default function VideoFavouritesModal({ video, remove, onClose, onSaved, itemLabel = "Video", onAdd = addVideoFavourites, onDelete = deleteVideoFavourites }) {
  const [count, setCount] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const submit = async (event) => {
    event.preventDefault();
    if (busy) return;
    const quantity = Number(count);
    if (!Number.isInteger(quantity) || quantity < 1 || quantity > 1000) {
      setError("Enter a whole number between 1 and 1000."); return;
    }
    setBusy(true); setError("");
    try {
      const result = await (remove ? onDelete : onAdd)(video.id, quantity);
      if (!result.success) throw new Error(result.message || "Unable to update favorites.");
      onSaved(video.id, result.totalFavourites, result.message);
    } catch (err) {
      setError(err.response?.data?.message || err.message || "Unable to update favorites.");
      setBusy(false);
    }
  };
  return (
    <Modal show centered backdrop="static" keyboard={!busy} onHide={busy ? () => {} : onClose}>
      <Modal.Header closeButton={!busy}><Modal.Title>{remove ? "Delete Favorites" : "Add Favorites"}</Modal.Title></Modal.Header>
      <Form onSubmit={submit}>
        <Modal.Body>
          <p>{itemLabel} {video.id} · Current favorites: {Number(video.favourite || 0).toLocaleString()}</p>
          <Form.Group>
            <Form.Label htmlFor="video-favorites-quantity">Number to {remove ? "delete" : "add"}</Form.Label>
            <Form.Control id="video-favorites-quantity" autoFocus type="number" min="1" max="1000" step="1" required
              value={count} disabled={busy} onChange={(event) => setCount(event.target.value)} />
          </Form.Group>
          {error && <Alert variant="danger" role="alert" className="mt-3">{error}</Alert>}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" disabled={busy} onClick={onClose}>Cancel</Button>
          <Button type="submit" variant={remove ? "danger" : "primary"} disabled={busy}>{busy ? "Saving…" : remove ? "Delete Favorites" : "Add Favorites"}</Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
